export enum GroupType {
    GROUP = 'group',
    TEAM = 'team',
    ORGANIZATION = 'organization',
    COMPANY = 'company',
    ASSOCIATION = 'association',
}
